import { render } from "./RdeMenuMobile.vue?vue&type=template&id=d546bd4e"
import script from "./RdeMenuMobile.vue?vue&type=script&lang=js"
export * from "./RdeMenuMobile.vue?vue&type=script&lang=js"

import "./RdeMenuMobile.vue?vue&type=style&index=0&id=d546bd4e&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__